var map = {
	"./en/dashboard.json": [
		83394,
		394
	],
	"./en/language.json": [
		63319,
		319
	],
	"./en/login.json": [
		28894,
		894
	],
	"./id/dashboard.json": [
		76015,
		15
	],
	"./id/language.json": [
		73718,
		718
	],
	"./id/login.json": [
		43924,
		924
	],
	"./jp/dashboard.json": [
		65811,
		811
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 10471;
module.exports = webpackAsyncContext;